<template>
  <el-dialog :title="$t('paymentPool.edit')" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
    <el-form ref="form" :model="editPaymentPoolInfo" label-width="120px">
      <el-form-item :label="$t('paymentPool.name')" prop="paymentName" required>
        <el-input v-model="editPaymentPoolInfo.paymentName" :placeholder="$t('paymentPool.requiredName')" />
      </el-form-item>

      <el-form-item :label="$t('paymentPool.paymentVendor')" prop="paymentType" required>
        <el-select v-model="editPaymentPoolInfo.paymentType" :placeholder="$t('paymentPool.requiredPaymentVendor')"
          style="width:100%" disabled>
          <el-option v-for="(item, index) in editPaymentPoolInfo.paymentTypes" :key="index" :label="item.name"
            :value="item.paymentType" />
        </el-select>
      </el-form-item>

      <el-form-item v-for="(item, index) in editPaymentPoolInfo.paymentKeys" :key="index" :label="item.name">
        <textarea v-model="item.columnValue" :placeholder="item.remark" />
      </el-form-item>

      <el-form-item v-if="editPaymentPoolInfo.paymentType === 'WECHAT'" :label="$t('paymentPool.merchantCert')">
        <upload-file ref="uploadFile" @notifyCert="handleCertUpload" />
      </el-form-item>

      <el-form-item :label="$t('paymentPool.paymentScope')" prop="payType" required>
        <el-select v-model="editPaymentPoolInfo.payType" :placeholder="$t('paymentPool.requiredPaymentScope')"
          style="width:100%" disabled>
          <el-option label="店铺费用" value="1001" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('paymentPool.status')" prop="state" required>
        <el-select v-model="editPaymentPoolInfo.state" :placeholder="$t('paymentPool.requiredStatus')"
          style="width:100%">
          <el-option :label="$t('paymentPool.enable')" value="Y" />
          <el-option :label="$t('paymentPool.disable')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('paymentPool.usageInstructions')">
        <el-input v-model="editPaymentPoolInfo.remark" type="textarea"
          :placeholder="$t('paymentPool.optionalInstructions')" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editPaymentPool">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updatePaymentPool, listPaymentKey, listPaymentAdapt, listPaymentPool } from '@/api/frame/paymentPool/paymentPoolApi'
import { getShopId } from '@/api/shop/shopApi'
import UploadFile from '@/components/frame/uploadFile/uploadFile.vue'

export default {
  name: 'EditPaymentPool',
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisible: false,
      editPaymentPoolInfo: {
        ppId: '',
        paymentName: '',
        paymentType: '',
        certPath: '',
        state: '',
        remark: '',
        paymentTypes: [],
        paymentKeys: [],
        payType: '',
        feeConfigs: [],
        configIds: []
      }
    }
  },
  methods: {
    open(paymentPool) {
      this.dialogVisible = true
      this.editPaymentPoolInfo = {
        ...paymentPool,
        paymentTypes: this.editPaymentPoolInfo.paymentTypes
      }
      this._loadEditPaymentAdapt()
      this._editChangeToType()
    },
    closeDialog() {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm() {
      this.editPaymentPoolInfo = {
        ppId: '',
        paymentName: '',
        paymentType: '',
        certPath: '',
        state: '',
        remark: '',
        paymentTypes: this.editPaymentPoolInfo.paymentTypes,
        paymentKeys: [],
        payType: '',
        feeConfigs: [],
        configIds: []
      }
      this.$refs.uploadFile && this.$refs.uploadFile.clearVedio()
    },
    async _loadEditPaymentAdapt() {
      try {
        const res = await listPaymentAdapt({ page: 1, row: 100 })
        this.editPaymentPoolInfo.paymentTypes = res.data
      } catch (error) {
        console.error('获取支付类型失败:', error)
      }
    },
    async _editChangeToType() {
      if (!this.editPaymentPoolInfo.paymentType) return

      try {
        const res = await listPaymentKey({
          paymentType: this.editPaymentPoolInfo.paymentType,
          page: 1,
          row: 100
        })
        this.editPaymentPoolInfo.paymentKeys = res.data.map(item => ({
          ...item,
          columnValue: ''
        }))
        this._editLoadPaymentData()
      } catch (error) {
        console.error('获取支付密钥失败:', error)
      }
    },
    async _editLoadPaymentData() {
      try {
        const res = await listPaymentPool({
          page: 1,
          row: 1,
          shopId: getShopId(),
          ppId: this.editPaymentPoolInfo.ppId
        })
        const paymentData = res.data[0]

        // 填充支付密钥值
        paymentData.values.forEach(value => {
          this.editPaymentPoolInfo.paymentKeys.forEach(key => {
            if (value.columnKey === key.columnKey) {
              key.columnValue = value.columnValue
            }
          })
        })

        // 填充配置ID
        if (paymentData.configs) {
          this.editPaymentPoolInfo.configIds = paymentData.configs.map(config => config.configId)
        }
        this.$forceUpdate()
      } catch (error) {
        console.error('获取支付数据失败:', error)
      }
    },
    handleCertUpload(fileInfo) {
      this.editPaymentPoolInfo.certPath = fileInfo.realFileName
    },
    async editPaymentPool() {
      try {
        this.editPaymentPoolInfo.shopId = getShopId()
        await updatePaymentPool(this.editPaymentPoolInfo)
        this.$message.success(this.$t('paymentPool.saveSuccess'))
        this.$emit('refresh')
        this.closeDialog()
      } catch (error) {
        console.error('更新支付配置失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 美化原生 textarea 样式，参考 Element UI
textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #606266;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-family: inherit;
  resize: vertical;
  
  &:hover {
    border-color: #c0c4cc;
  }
  
  &:focus {
    outline: none;
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
  
  &::placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }
  
  &:disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}

// 表单项标签样式优化
.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

// 整体表单样式优化
.el-form {
  .el-form-item {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>